/**
 * XpToast · v6.7.6 F5
 * Toast animado "+10 XP" tipo videojuego cuando el user gana/pierde XP.
 *
 * Escucha el evento global window:'gamif:xp-gain' { delta, descripcion }.
 * Auto-dismiss en 2.5s. Apila max 3 toasts.
 */
import { useState, useEffect } from "react";
import { cn } from "../lib/utils.js";

let _idSeq = 0;

export default function XpToast() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const handler = (e) => {
      const { delta = 0, descripcion = "" } = e.detail || {};
      if (!delta) return;
      const id = ++_idSeq;
      setToasts(prev => [...prev.slice(-2), { id, delta, descripcion }]);
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, 2500);
    };
    window.addEventListener("gamif:xp-gain", handler);
    return () => window.removeEventListener("gamif:xp-gain", handler);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed bottom-6 right-6 z-[9999] flex flex-col-reverse gap-2">
      {toasts.map(t => (
        <div
          key={t.id}
          className={cn(
            "px-4 py-2 rounded-xl border shadow-lg font-bold flex items-center gap-2 animate-xp-pop",
            t.delta > 0
              ? "bg-[#8B5CF6]/95 text-white border-[#C4B5FD]"
              : "bg-[#DC2626]/95 text-white border-[#FCA5A5]"
          )}
          style={{ animation: "xpPop 2.5s ease-out forwards" }}
        >
          <span className="text-2xl">{t.delta > 0 ? "+" : ""}{t.delta}</span>
          <span className="text-xs opacity-90">XP · {t.descripcion}</span>
        </div>
      ))}
      <style>{`
        @keyframes xpPop {
          0%   { opacity: 0; transform: translateY(20px) scale(0.8); }
          15%  { opacity: 1; transform: translateY(0) scale(1.1); }
          25%  { transform: translateY(0) scale(1); }
          85%  { opacity: 1; transform: translateY(0); }
          100% { opacity: 0; transform: translateY(-20px); }
        }
      `}</style>
    </div>
  );
}
